var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("accounting")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-ledger-account-autocomplete", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("ledger-account"),
                      "add-remove-button": "",
                    },
                    model: {
                      value: _vm.product.LedgerAccountCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "LedgerAccountCode", $$v)
                      },
                      expression: "product.LedgerAccountCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }